import { createContext } from 'react';

const initialContext: CardPreviewContextValues = {
  hideEmptyAttributes: false,
};

export interface CardPreviewContextValues {
  hideEmptyAttributes?: boolean | undefined;
}

const cardPreviewContext = createContext<CardPreviewContextValues>(initialContext);

export { cardPreviewContext };
